import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { HelpText } from "Components/Shared/HelpText/HelpText";
import useStyles from "./styles";
import { CashBalanceTable } from "./CashBalanceTable/CashBalanceTable";
import { CashBalanceReportActions } from "./CashBalanceReportActions/CashBalanceReportActions";

export const CashBalanceReport = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      <HelpText>
        <b>What is the Cash Balance Report?</b> Evidence that the amount of money remitted to the DailyPay Account (DPA) is equal to the amount of money transferred to user personal bank accounts and cards (less fees paid if applicable).  The money remitted to the DPA may not equal the amount of money transferred to the user if the user has a negative balance from the previous pay period or if the user has invalid banking information (causing funds to be temporarily withheld).
      </HelpText>
      <CashBalanceReportActions />
      <Grid item xs={12}>
        <Typography variant="h3" className={classes.tableTitle}>
          Cash Balance Report
        </Typography>
        <CashBalanceTable />
      </Grid>
    </Grid>
  );
};
